



























































































import Vue from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.addLicense("CH197967928");
export default Vue.extend({
    name: "Data",
    data() {
        return {
            graphData: [{}]
        }
    },
    mounted() {
        this.graphData = this.getData();
        this.renderGraph();
    },
    methods: {
        renderGraph() {
            am4core.useTheme(am4themes_animated);

            let chart = am4core.create("datausageDiv", am4charts.XYChart);

            chart.data = this.graphData;

            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "data";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

            let series = chart.series.push(new am4charts.ColumnSeries());

            series.dataFields.valueY = "usage";
            series.dataFields.categoryX = "data";
            series.name = "Usage";
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = .8;
            valueAxis.renderer.labels.template.disabled = true;

            let columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        },
        filterData() {
            this.graphData = this.getData();
            this.renderGraph();
        },
        getData() {
            return [{
                "data": "Google",
                "usage": Math.floor(Math.random() * 300)
            }, {
                "data": "Facebook",
                "usage": Math.floor(Math.random() * 300)
            }, {
                "data": "YouTube",
                "usage": Math.floor(Math.random() * 300)
            }, {
                "data": "All Access",
                "usage": Math.floor(Math.random() * 300)
            }]
        },
        toggle(el: any) {
            el.target.classList.toggle("active");
            el.target.nextElementSibling.classList.toggle("show");
        }
    }
});
